<template lang="html">
  <div class="">
    <span v-if="context.action == 'voted'">
      <!-- start 'voted' -->
      <span v-if="context.details.bill == 'None'">
        Voted "{{ context.details.vote_cast }}" (rollcall
        <a target="_blank" v-bind:href="context.details.rollcall_link"
          >#{{ context.details.rollcall }}</a
        >)
      </span>
      <span v-else>
        Voted "{{ context.details.vote_cast }}" on bill
        <a target="_blank" v-bind:href="context.details.bill_link">{{
          context.details.bill.toUpperCase()
        }}</a>
        (rollcall
        <a target="_blank" v-bind:href="context.details.rollcall_link"
          >#{{ context.details.rollcall }}</a
        >)
      </span>
      <!-- end 'voted' -->
    </span>
    <span v-else-if="context.action == 'mentioned'">
      <!-- start 'mentioned' -->
      Mentioned in news ({{ context.details.articles.length }} articles -
      <a @click="showArticles" href="#"
        >{{ showMentions ? "hide" : "see" }} articles</a
      >)
      <div v-if="showMentions">
        <div
          class="row pt-2"
          v-for="article in context.details.articles"
          :key="article.url"
        >
          <div class="col-12">
            <a
              class="fc-a-link--casual"
              target="_blank"
              v-bind:href="article.url"
              >{{ article.title }}</a
            >
          </div>
          <div class="col-12 small">
            {{ article.source.title }} <i>{{ getDate(article.date) }}</i>
          </div>
        </div>
      </div>
      <!-- end 'mentioned' -->
    </span>
    <span v-else-if="context.action == 'spoke'">
      <!-- start 'spoke' -->
      Spoke on chamber floor ("{{ context.details.title }}"
      <a target="_blank" v-bind:href="getTranscriptLink(context.id)"
        >see transcript</a
      >)
      <!-- end 'spoke' -->
    </span>
    <span v-else-if="context.action == 'sponsored'">
      <!-- start 'sponsored' -->
      Sponsored new bill
      <a target="_blank" v-bind:href="context.details.bill_link">{{
        context.details.bill.toUpperCase()
      }}</a>
      <!-- end 'sponsored' -->
    </span>
    <span v-else-if="context.action == 'committee-report'">
      <!-- start 'committee-report' -->
      <span v-if="context.details.bill != 'None'">
        <a v-bind:href="context.details.committee_link" target="_blank">{{
          context.details.committee
        }}</a>
        reported on bill
        <a v-bind:href="context.details.bill_link" target="_blank">{{
          context.details.bill.toUpperCase()
        }}</a>
        (<a v-bind:href="context.details.report_link" target="_blank"
          >see report</a
        >)
      </span>
      <span v-else>
        <a v-bind:href="context.details.committee_link" target="_blank">{{
          context.details.committee
        }}</a>
        reported to Congress (<a
          v-bind:href="context.details.report_link"
          target="_blank"
          >see report</a
        >)
      </span>
      <!-- end 'committee-report' -->
    </span>
    <span
      v-else-if="
        [
          'voted-bipartisan-70',
          'voted-bipartisan-80',
          'voted-bipartisan-90'
        ].includes(context.action)
      "
    >
      <!-- start 'maverick' -->
      <span v-if="context.details.bill != 'None'">
        Maverick bonus: Voted against {{ context.action.split("-")[2] }}% of
        party on bill
        <a target="_blank" v-bind:href="context.details.bill_link">{{
          context.details.bill.toUpperCase()
        }}</a>
        (rollcall
        <a target="_blank" v-bind:href="context.details.rollcall_link"
          >#{{ context.details.rollcall }}</a
        >)
      </span>
      <span v-else>
        Maverick bonus: Voted against {{ context.action.split("-")[2] }}% of
        party (rollcall
        <a target="_blank" v-bind:href="context.details.rollcall_link"
          >#{{ context.details.rollcall }}</a
        >)
      </span>
      <!-- end 'maverick' -->
    </span>
    <span
      v-else-if="
        ['passed-sponsor', 'passed-cosponsor'].includes(context.action)
      "
    >
      <!-- start 'passed' -->
      <a v-bind:href="context.details.bill_link" target="_blank">{{
        context.details.bill.toUpperCase()
      }}</a>
      passed by {{ context.details.chamber }} ({{
        context.action.split("-")[1]
      }})
      <!-- end 'passed' -->
    </span>
    <span v-else>
      {{ context.action }}
    </span>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "Action",
  data: function() {
    return {
      showMentions: false
    };
  },
  props: ["context"],
  methods: {
    getTranscriptLink: function(id) {
      return `${process.env.VUE_APP_CONGRESS}/api/members/${
        this.context.member
      }/actions/${id}/transcript/`;
    },
    showArticles: function(e) {
      e.preventDefault();
      this.showMentions = this.showMentions == false ? true : false;
    },
    getDate: function(date) {
      let eastern = moment
        .utc(date, "YYYY-MM-DD h:mm:ss z")
        .tz("America/New_York");
      return eastern.format("MM-DD-YYYY h:mma z");
    }
  }
};
</script>

<style lang="scss"></style>
